// Presentation only: consume existing review evidence without granting any
// approval, setup, publication, or execution capability. Legacy artifact
// presentation remains frozen unless a pending allocation or historical verdict
// explicitly calls for the proposed-plan view. Existing campaign/setup
// authorization keeps its real readiness presentation during a later proposal.
export const isMicrositePlanningReview = ({
  approvalAuthority, governance, allocationStatus, presentationCurrent = false,
} = {}) =>
  approvalAuthority?.campaignApproval?.state !== "AUTHORIZED" &&
  (allocationStatus === "PENDING_APPROVAL" ||
  (presentationCurrent && (
    ["AWAITING_APPROVAL", "NEEDS_REAPPROVAL", "NEEDS_CORRECTION", "REVOKED"].includes(
      approvalAuthority?.strategyApproval?.state
    ) || governance?.status === "AWAITING_APPROVAL"
  )) ||
  governance?.status === "ALLOCATION_APPROVAL_REQUIRED");
